
import { Component, Prop, Vue, Watch } from "vue-property-decorator";

import SoftSkillsMultiselect from "@/components/autocompleteMultiselects/SoftSkillsMultiselectNew.vue";

import SoftSkillMultiselectItem from "@/components/skills/SoftSkillMultiselectItem.vue";
import SoftSkillMultiselectOption from "@/entities/SoftSkillMultiselectOption";

@Component({
  components: {
    SoftSkillMultiselectItem,
    SoftSkillsMultiselect,
  },
})
export default class CustomSoftSkillsMultiselect extends Vue {
  @Prop({ type: Array, required: true }) readonly previouslyChosenSoftSkillsIds!: number[];
  @Prop({ type: String, default: "Add new soft skill" }) readonly customSoftSkillLabel!: string;
  @Prop({ type: String, default: "Add new soft skill" }) readonly newSoftSkillLabel!: string;
  @Prop({ type: Boolean, default: false }) readonly disabled!: boolean;
  @Prop({ type: Number, default: undefined }) readonly max?: number;
  @Prop({ type: String, default: "" }) readonly getParentContainer!: string;
  @Prop({ type: String, default: null }) readonly companyId?: string;

  newSoftSkillsNames: string[] = [];
  softSkillsIdsFromDB: number[] = [];
  searchQuery: string = "";

  @Watch("previouslyChosenSoftSkillsIds", { immediate: true })
  onSoftSkillsIdsChanged(): void {
    this.softSkillsIdsFromDB = this.previouslyChosenSoftSkillsIds;
  }

  search(query: string) {
    this.searchQuery = query;
  }

  updateSoftSkillList(softSkillsIdsFromDB: number[], allChosenSoftSkills: SoftSkillMultiselectOption[]): void {
    const newSoftSkillsNames = allChosenSoftSkills
      .filter(chosenSoftSkill => Number(chosenSoftSkill.id) < 0)
      .map(({ name }) => name);

    this.$emit("softSkillsListUpdated", softSkillsIdsFromDB, newSoftSkillsNames, allChosenSoftSkills);
  }
}
